import { apiSlice } from "../../app/api/apiSlice";

export const resetApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		reset: builder.mutation({
			query: (credentials) => ({
				url: "/api/v1/tpo/reset_password/",
				method: "POST",
				body: credentials,
			}),
		}),
	}),
});

export const { useResetMutation } = resetApiSlice;
